<template>
  <component :is="layoutComponent" v-bind="layoutProps">
    <template slot="field">
      <div class="text-field-with-email">
        <div class="text-field-input-wrap">
          <input
            :id="field.attribute"
            v-model="fieldValue"
            :type="inputType"
            :min="inputMin"
            :max="inputMax"
            :step="inputStep"
            :pattern="inputPattern"
            class="form-control"
            :class="errorClasses"
            :placeholder="inputPlaceholder"
            :readonly="isReadonly"
            :disabled="isDisabled"
            v-bind="field.attrs"/>
        </div>
        <a
          v-if="field.emailBtn"
          href="#"
          target="_blank"
          rel="noopener noreferrer"
          class="email-btn"
          @click="openDialog"
        >
          <i class="icon-mail5"></i>
        </a>
      </div>
    </template>
  </component>
</template>

<script>
import { FormTextField } from 'stylemix-base'
import { VueTelInput } from 'vue-tel-input'
import { create } from 'vue-modal-dialogs'
import EmailMessage from '../../companies/EmailMessage.vue'

export default {
  name: 'EmailField',

  components: { VueTelInput },

  extends: FormTextField,

  created() {
    if(this.model.vehicle_model)
      this.messageDialog = create(EmailMessage, 'driverEmail')
    else
      this.messageDialog = create(EmailMessage, 'customerEmail')
  },
  methods: {
    openDialog($event) {
      $event.preventDefault()
      this.messageDialog(this.fieldValue)
    }
  }
}
</script>

<style scoped lang="scss">
.text-field-with-email {
  display: flex;
  align-items: center;
  gap: 10px;
}

.text-field-input-wrap {
  flex: 1;
  min-width: 0;
}

.email-btn {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  text-decoration: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;

  background-color: #fff;
  border: 1px solid #dee2e6;
  color: #495057;
  i {
    font-size: 17px;
    svg {
      display: block;
      fill: #495057;
    }
  }

  &:hover {
    background-color: #dcf8dc;
    border-color: #25d366;
    color: #25d366;
    transition: background-color 0.2s, border-color 0.2s, color 0.2s;

  }

  &[aria-disabled='true'] {
    cursor: default;
    pointer-events: none;
  }
}
</style>
